import { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const api_url = process.env.REACT_APP_API_URL || "";

function generateState() {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

function TelegramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      width="20"
      height="20"
      style={{ flexShrink: 0 }}
    >
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  );
}

function TelegramLoginButton() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClick = async () => {
    setLoading(true);
    setError('');
    try {
      const state = generateState();
      sessionStorage.setItem('telegram_oauth_state', state);

      const redirectUri = window.location.origin + '/telegram/callback';
      const res = await axios.get(api_url + '/api/auth/telegram/redirect/', {
        params: { redirect_uri: redirectUri, state },
      });
      window.location.href = res.data.url;
    } catch {
      setError(t('login.telegram_error'));
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '24px 0' }}>
        <div style={{ flex: 1, height: '1px', background: 'var(--border-color, #e5e7eb)' }} />
        <span style={{ color: 'var(--text-secondary, #9ca3af)', fontSize: '13px', whiteSpace: 'nowrap' }}>
          {t('login.or')}
        </span>
        <div style={{ flex: 1, height: '1px', background: 'var(--border-color, #e5e7eb)' }} />
      </div>

      {error && (
        <div className="alert alert-danger mb-3" role="alert">{error}</div>
      )}

      <button
        onClick={handleClick}
        disabled={loading}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          width: '100%',
          padding: '10px 20px',
          background: loading ? '#1a8bbf' : '#2AABEE',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          fontSize: '15px',
          fontWeight: '500',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'background 0.2s',
          opacity: loading ? 0.8 : 1,
        }}
        onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = '#1a8bbf'; }}
        onMouseLeave={(e) => { if (!loading) e.currentTarget.style.background = '#2AABEE'; }}
      >
        <TelegramIcon />
        {loading ? t('login.telegram_loading') : t('login.telegram_button')}
      </button>
    </div>
  );
}

export default TelegramLoginButton;
